import { BaseTopMenuApi } from './api.base';

export class BoxTopMenuApi extends BaseTopMenuApi {

}
